/// <amd-module name="Test/TestCaseResults/Services/TestCaseResultsBreadCrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { Services, VssService } from "VSS/Platform/Context";
import { FastPageSwitch } from "VSS/Platform/FPS";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

// import { IVssContributionService } from "VSS/Platform/Contribution";
export class TestCaseResultsBreadCrumbService extends VssService implements IBreadcrumbItemService {
    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public addBreadCrumb(key: string, name: string, url: string, rank: number) {
        this.items.push({
            key: key,
            text: name,
            rank: rank,
            onClick: url
                ? () => {
                      FastPageSwitch(this.pageContext, url, true);
                  }
                : undefined
        });
    }
}

export const TestCaseResultsBreadCrumbServiceName = "testcase-results-breadcrumb-service";
Services.add(TestCaseResultsBreadCrumbServiceName, { serviceFactory: TestCaseResultsBreadCrumbService });
